import chatElements from '../config/chatElements';
import { addMessage, askNextQuestion } from '../config/chatUtils';
import { formQuestions, checkAndOfferStoredData } from '../config/chatFormHandling';
import { 
    setCurrentFlow,
    getCurrentFlow,
    setCurrentQuestionIndex,
    getCurrentQuestionIndex,
} from '../config/chatState';

const { chatBody, chatInput } = chatElements;

// Questions with validation functions
const scheduleQuestions = formQuestions('schedule');


function startScheduleFlow(first = null) {
    setCurrentFlow('schedule');
    if (first) {
        addMessage("Schedule a call with a benefits advisor", 'user', 500);
    }

    const prompted = checkAndOfferStoredData('schedule', scheduleQuestions);

    if (!prompted) {
        addMessage("Great! I just need to ask you a few quick questions to make sure we connect you with the best advisor for your business.", 'bot', 1250);
        setCurrentQuestionIndex(0);
        setTimeout(() => askNextQuestion('schedule'), 1500);
    }
}

export { 
	scheduleQuestions,
    startScheduleFlow
};